<div #collapsible class="collapse" [id]="collapseQualifierId">
    <div class="card card-body">
        <div class="row">
            <div class="col-11">
                <div class="row header-row">
                    <div id="qualifiersLabel" class="col-12">{{'qualifiers' | i18next}}:</div>
                </div>
                <div class="row" *ngFor="let term of entry.qualifiers; index as i">
                    <div class="col-12 input-row">
                        <input type="checkbox" name="term{{i}}" id="term{{i}}" value="{{term.name}}" (click)="onQualifierCheckboxChange(term.name, $event)" [checked]="termsService.isQualifierTermChecked(term.name, entry.name)">
                        <label id="label-{{term.id}}" for="term{{i}}">{{term.name}} ({{term.alt}})</label>
                        <a id="term-{{term.id}}" role="button" 
                            href="#qualDescr-{{getQualifierId()}}-{{i}}" tabindex="0"
                            (click)="toggleCollapse('qualDescr-' + getQualifierId() + '-' + i, $event, i)" 
                            [attr.aria-expanded]="false" 
                            [attr.aria-controls]="'qualDescr-' + getQualifierId() + '-' + i"
                            [attr.aria-labelledby]="'label-' + term.id">
                            <svg id="chevron-double-down-{{getQualifierId()}}-{{i}}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-down" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                <path fill-rule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                            </svg>
                            <svg id="chevron-double-up-{{getQualifierId()}}-{{i}}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-up hidden" viewBox="0 0 16 16">
                               <path fill-rule="evenodd" d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708z"/>
                                <path fill-rule="evenodd" d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                            </svg>
                        </a>
                        <div class="collapse" id="qualDescr-{{getQualifierId()}}-{{i}}">
                            <div class="card card-body qualifier-description">
                                <span>{{term.description}}</span>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        
            <div class="col-1 collapse-close-btn-wrapper">
                <div class="collapse-close-btn" role="button" aria-label="Close term" tabindex="0" (click)="closeBtn(collapseQualifierId);" (keydown.enter)="closeBtn(collapseQualifierId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16" focusable="false" aria-hidden="true">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" role="presentation"/>
                    </svg>
                </div>
            </div>  
        </div>
    </div>
</div>